import React, { useState } from "react";
import GenerateInvoiceMetrics from "./_generateinvoicemetrics";
import InvoicingTable from "./_invoicingtable";

export default function TenantInvoice() {
  const currentDate = new Date();
  const currentMonth = currentDate.toLocaleString('default', { month: 'long' }).toLowerCase();
  const currentYear = currentDate.getFullYear().toString();
  const [selectedMonth, setSelectedMonth] = useState(currentMonth);
  const [selectedYear, setSelectedYear] = useState(currentYear);

  return (
    <>
      <GenerateInvoiceMetrics month={selectedMonth} year={selectedYear} />
      <InvoicingTable
        month={selectedMonth}
        year={selectedYear}
        onMonthChange={setSelectedMonth}
        onYearChange={setSelectedYear}
      />

    </>
  )
}
